import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';

@Injectable()
export class BullhornRetryInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes('bullhornstaffing.com')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      retry({
        count: 2,
        delay: (error, retryCount) => {
          console.log(`Retry attempt ${retryCount} for ${request.url}`);

          const jitter = 0.5;
          const baseDelay = 1000;
          const jitterFactor = 1 + (Math.random() * 2 - 1) * jitter;
          const retryDelay = (baseDelay * jitterFactor) + (retryCount * 1000);

          return new Observable(subscriber => {
            const timeout = setTimeout(() => {
              subscriber.next(undefined);
              subscriber.complete();
            }, retryDelay);

            return () => clearTimeout(timeout);
          });
        }
      })
    );
  }
}
